import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SettingsEvent} from '../classes/settings-event.enum';
import {SettingsType} from '../enums/settings-type.enum';

@Injectable({
  providedIn: 'root'
})
export class InteractionService {

  public fractalInfoVisibility: BehaviorSubject<boolean>;
  public fractalSettingsVisibility: BehaviorSubject<boolean>;
  public fractalControlsVisibility: BehaviorSubject<boolean>;
  public fractalSettings: BehaviorSubject<SettingsEvent>;

  constructor() {
    this.fractalInfoVisibility = new BehaviorSubject<boolean>(true);
    this.fractalSettingsVisibility = new BehaviorSubject<boolean>(true);
    this.fractalControlsVisibility = new BehaviorSubject<boolean>(true);
    this.fractalSettings = new BehaviorSubject<SettingsEvent>(new SettingsEvent(SettingsType.RESET, 0));
  }
}
